import styled from '@emotion/styled';

import { tokens, Text } from '@hotjar/hotsauce';

export const PopoverHeaderText = styled(Text)`
  margin: 0;
  padding-bottom: ${tokens.spacer.x1};
  padding-top: ${tokens.spacer.x3};

  &:first-of-type {
    padding-top: 0;
  }
`;
